import type { WidgetType } from '../data/widgetTypeDefinitions'

export const WIDGET_EDITOR_TABS = ['overview', 'analytics', 'content', 'display', 'design'] as const
export type WidgetEditorTab = (typeof WIDGET_EDITOR_TABS)[number]

const WIDGET_TYPE_LABELS: Readonly<Record<WidgetType, string>> = {
  modal: 'Popup',
  toaster: 'Toaster',
  bar: 'Bar',
  inline: 'Embedded',
  takeover: 'Full-screen takeover'
}

export function widgetTypeLabel(type: string): string | undefined {
  return Object.hasOwn(WIDGET_TYPE_LABELS, type) ? WIDGET_TYPE_LABELS[type as WidgetType] : undefined
}

export function resolveWidgetEditorLocation(tab: unknown, hash: string, embedded: boolean) {
  if (tab === 'visibility') {
    return { tab: 'display' as const, hash: '#pages' }
  }
  if (tab === 'behavior' || tab === 'trigger') {
    return { tab: 'display' as const, hash: '#trigger' }
  }
  const resolved = WIDGET_EDITOR_TABS.find((value) => value === tab)
  return { tab: resolved && !(embedded && resolved === 'content') ? resolved : ('overview' as const), hash }
}
